<template>
  <div class="home">
  <pcitem v-bind:podcastitems="podcastitems" />
  </div>
</template>




<script>
import axios from 'axios'
import pcitem from '../components/Podcastitems'
export default {
name: 'Podcasts',
  components: {
     pcitem
  },
  data(){
    return {
      podcastitems: [
        'asdeas','asdas','asdasd'
      ]
    }
  },
  created(){
    axios.get('https://jsonplaceholder.typicode.com/todos?_limit=4').then(data=>{
      this.podcastitems = data.data;
    })
  }
}
</script>
